import React, { ForwardedRef, forwardRef, useRef } from "react";
import classNames from "classnames";
import { CheckboxTileProps } from "./types";

const getIconProps = () => ({
  fill: "currentColor",
  className: "rds-CheckboxTile-icon",
  ["aria-hidden"]: true,
  focusable: false,
});

const CheckboxTile = forwardRef(
  (
    {
      className,
      icon: CheckboxTileIcon,
      id: idProp,
      image,
      label,
      size = "md",
      vertical,
      ...rest
    }: CheckboxTileProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const defaultIdRef = useRef(
      `rds-checkboxtile-${Math.random().toString(36).slice(2, 16)}`
    );

    const id = idProp || defaultIdRef.current;

    const checkboxTileClasses = classNames(
      "rds-CheckboxTile",
      {
        [`rds-CheckboxTile--${size}`]: size !== "md",
        "rds-CheckboxTile--vertical": vertical,
      },
      className
    );

    return (
      <div className={checkboxTileClasses}>
        <input type="checkbox" ref={ref} id={id} {...rest} />
        <label htmlFor={id}>
          <span className="rds-CheckboxTile-box"></span>
          <span className="rds-CheckboxTile-content">
            {CheckboxTileIcon && !vertical && (
              <CheckboxTileIcon {...getIconProps()} />
            )}
            {image && vertical && (
              <span className="rds-CheckboxTile-image">{image}</span>
            )}
            {label}
          </span>
        </label>
      </div>
    );
  }
);

CheckboxTile.displayName = "CheckboxTile";

export { CheckboxTile as default };
